import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Logo from '../Assets/InsuranceExchange_logo.svg';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { useState } from "react";
import AuthUser from '../AuthUser'
function Adminlogin() {
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState("fa-solid fa-eye-slash");
  const show = () => {
    type === "password" ? setType("text") : setType("password");
    icon === "fa-solid fa-eye"
      ? setIcon("fa-solid fa-eye-slash")
      : setIcon("fa-solid fa-eye");
  };
  const [values, setValues] = useState({ email: '', password: '' })
  const [errors, setErrors] = useState({ email: '', password: '', message: '' })
  const { http, setToken } = AuthUser();
  function handleChange(e) {
    setValues({ ...values, [e.target.name]: e.target.value })
  }
  //Validate login form
  const ValidateForm = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const newErrors = { ...errors };
    // Validate email
    if (!values.email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!emailRegex.test(values.email)) {
      newErrors.email = 'Email not valid';
      isValid = false;
    } else {
      newErrors.email = '';
    }

    // Validate password
    if (!values.password.trim()) {
      newErrors.password = 'Password is required';
      isValid = false;
    } else {
      newErrors.password = '';
    }

    setErrors(newErrors);
    return isValid;

  }
  // Handle Submit for login api
  const handleSubmit = async (e) => {
    e.preventDefault();
    //validation(values);
    let email = values.email;
    let password = values.password;
    const newErrors = { ...errors };
    if (ValidateForm()) {
      http.post(`admin/adminlogin`, { email: email, password: password })
        .then((response) => {
          console.log(response.data)
          //setToken(response.data.userdetail,response.data.token);
          const { userdetail, token } = response.data;
          // Check the role and store different sets of data
          setToken(userdetail, token, 'agent');
        })
        .catch(function (error) {
          // handle error
          console.log(error);
          if (error?.response?.status == 403) {
            newErrors.email = error.response.data?.error?.email;
            newErrors.password = error.response.data?.error?.password;
            setErrors(newErrors);
          }
          if (error?.response?.status == 401) {
            newErrors.message = error?.response?.data?.error;
            setErrors(newErrors);
          }
          //setsubmitted(false)
        })
    }
  }
  return (
    <Container fluid className='Regbg pt-4 pb-4'>
      <Row className='min-vh-75'>
        <Card className='rounded-0' style={{ width: '25rem', margin: 'auto' }}>
          <Card.Body>
            <Row>
              <Col lg={12}>
                <img src={Logo} alt='Profile' className='img-fluid p-2 ' />
                <h6 className='text-center fw-bold'> Admin Login</h6>
                <Form method="post" className='mt-3' onSubmit={handleSubmit} >
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Control type="email" name="email" onChange={handleChange} className='rounded-0 p-3 shadow-sm' placeholder="Email" />
                    <span style={{ display: 'block', color: "#bc3f34" }} className="invalid-feedback">{errors.email}</span>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Control type={type} name="password" onChange={handleChange} className='rounded-0 p-3 shadow-sm' placeholder="Password" />
                    <i onClick={show} className={icon} style={{ float: "right", marginRight: '5px', marginTop: '-30px', position: "relative", zIndex: "2" }}></i>
                    <span style={{ display: 'block', color: "#bc3f34" }} className="invalid-feedback">{errors.password}</span>
                    <div style={{ display: "block" }} className="invalid-feedback small">{errors.message}</div>
                  </Form.Group>
                  <div className="d-grid gap-2">
                    <Button variant="primary" size="sm" type="submit" onClick={ValidateForm} style={{ backgroundColor: "#2F9DCC" }} className='rounded-0 fw-bold border-0 shadow'> Login </Button>
                  </div>
                </Form>
                <p className='text-center mt-2 p-0'><Card.Link as={Link} to="/ForgotPassword">Forgot Password?</Card.Link></p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Row>
    </Container>

  );
}

export default Adminlogin